// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"b316ee60","396":"d759cd25","514":"45b19088","951":"171ea691"}[chunkId] + ".chunk.css";
};